import {
  LessonRecordingFieldsFragment,
  useRecentlyMatchedQuery,
} from 'core/graphql';

export type RecentMatchRow = LessonRecordingFieldsFragment;

interface IUseRecentlyMatched {
  rows: RecentMatchRow[];
  loading: boolean;
  error?: string;
  refetch: () => void;
}

/**
 * Most-recently-matched LessonRecordings (newest first) — backs the «Recent»
 * tab. `mine` scopes to the current user's matches; the list is independent of
 * the shared date filter so the user can always jump back to what they just
 * matched.
 */
export const useRecentlyMatched = (
  mine: boolean,
  limit = 20,
): IUseRecentlyMatched => {
  const { data, loading, error, refetch } = useRecentlyMatchedQuery({
    variables: { mine, limit },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    rows: (
      data?.recentlyMatchedLessonRecordings ?? []
    ).filter((row): row is RecentMatchRow => Boolean(row)),
    loading,
    error: error?.message,
    refetch: () => {
      refetch();
    },
  };
};
